import { Box, styled } from "@mui/material";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import Loading from "react-loading";

const Card = styled(Box)({
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.084), 0px 2px 3px rgba(0, 0, 0, 0.168)',
    padding: '32px 24px',
    maxWidth: '400px',
    backgroundColor: '#fff',
    color: '#212121',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    boxSizing: 'border-box',
    borderRadius: '10px',
    fontSize: '14px',
    fontFamily: 'inherit',
    '.text-head': {
        textAlign: 'center',
        fontWeight: '1000',
        fontSize: '18px',
        color: '#5382c2',
        marginBottom: '5px'
    },
    '.form': {
        gap: '15px',
        padding: '15px',
        display: 'flex',
        flexDirection: 'column',
        marginTop: '-20px',
        justifyContent: 'center',
    },
    '.find': {
        top: '50%',
        left: '50%',
        padding: '10px 16px',
        borderRadius: '20px',
        fontFamily: 'inherit',
        border: '1px solid #ccc',
        width: '80%',
        marginLeft: '12px'
    },
    '.button': {
        boxShadow: '0px 0px 3px rgba(0, 0, 0, 0.084), 0px 2px 3px rgba(0, 0, 0, 0.168)',
        borderRadius: '20px',
        backgroundColor: '#5382c2',
        color: '#fff',
        display: 'flex',
        gap: '8px',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        justifyContent: 'center',
        alignItems: 'center',
        border: 'none',
        width: '50%',
        padding: '10px 16px',
        cursor: 'pointer',
        marginLeft: '80px',
        marginTop: '10px'
    },
    '.button:active': {
        scale: '0.95'
    },
    '.find::placeholder': {
        opacity: '0.5'
    },
    '.find:focus': {
        outline: 'none',
        borderColor: '#1778f2'
    },
    '.img': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '-30px',
        marginBottom: '-20px',
        marginLeft: '10px'
    },
    '.contentload': {
        width: '100%',
        color: 'black',
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'row'
    }
})


const IsCard = () => {
    const [formIDCard, serFormIDCard] = useState({ idcard: "" });
    const [formRandom, setRanDom] = useState({ random: "" });
    const { random } = formRandom;
    const { idcard } = formIDCard;
    const navigate = useNavigate();
    // const [password, setPassword] = useState(false)
    // let idToken = "token2d0a71fae3a80ea4d803f03af371d427";
    const [isShow, setIsShow] = useState(false);
    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(false);
    const tokens = "32a9fcf38fb1aebaed";
    const bodyCondition = {
        idcard: { formIDCard },/*"1459900148279"*/
        getdata: "all",
        randomToken: { formRandom }/*"token2d0a71fae3a80ea4d803f03af371d427"*/
    }

    //   const togglePassword = () => {
    //     setPassword(!password);
    //   };

    const initgenKey = async () => {
        const requestOptions = {
            method: 'POST',
            redirect: 'follow'
        };
        try {
            const res = await fetch('https://api.myhealthgroup.net/authentication/ramdomtoken', requestOptions)
            const json = await res?.json()
            const payload = json?.payload
            setRanDom(payload?.token)
        }
        catch (error) {
            console.log(error)
        }
    }


    const handletShowPassword = () => setIsShow(!isShow)

    const handleGetData = async () => {
        setIsLoading(true)
        await axios.post(`https://api.myhealthgroup.net/apiservice/thg/gethealthhistorylist`, { ...bodyCondition }, {
            headers: {
                Authorization: `Bearer ${tokens}`
            }
        }
        )
            .then(res => {
                if (res.status === 200) {
                    setData(res.data?.payload)
                    setIsLoading(false);
                }
            })
            .catch(error => {
                console.log(error)
                setIsLoading(false)
            })
    }

    useEffect(() => {
        handleGetData();
    }, [])


    const handleIDcard = (event) => {
        serFormIDCard(event.target.value);
    }
    const handleFormRandom = (event) => {
        setRanDom(event.target.value);
    }

    const getHospitalData = async () => {
        try {
            setIsLoading(true)
            const url = "https://api.myhealthgroup.net/apiservice/thg/gethealthhistorylist"
            const params = {
                idcard: formIDCard,
                getdata: "all",
                randomToken: formRandom
            }
            const options = {
                headers: {
                    Authorization: `Bearer ${tokens}`,
                },
            }
            const response = await axios.post(url, params, options);
            if (response.status === 200) {
                return response.data?.payload;
            }
        } catch (error) {
            console.log(error)
        }
    }


    const handleSubmit = async (event) => {
        const tempHospitalData = await getHospitalData();
        setIsLoading(false)

        if (tempHospitalData) {
            const obj = {
                data: tempHospitalData,
                idcard: formIDCard,
                random: formRandom
            }

            navigate(`/hospital`, { state: obj });

        }
        else {
            Swal.fire({
                title: 'กรุณากรอกข้อมูลให้ถูกต้อง!',
                icon: 'error',
                confirmButtonText: 'OK',
                confirmButtonColor: '#313131'
            });

            return;
        }
    }
    return (
        <Card>
            <img className="img" src="/image/7015994.png" />
            <div className="form" >
                <label className="text-head">Search API Data :</label>
                <input className="find" name="idcard" placeholder="ID Card" onChange={(e) => handleIDcard(e)} />
                <Box sx={{ position: "relative" }}>
                    <input type={isShow ? 'test' : 'password'} className="find" name="random" onChange={(e) => handleFormRandom(e)} placeholder="Random Key"></input>
                    <RemoveRedEyeIcon
                        onClick={handletShowPassword}
                        sx={{
                            position: 'absolute',
                            right: '-1.1em', top: '20%',
                            transform: 'translate(-50%)',
                            opacity: isShow ? '1' : '0.2'
                        }}
                    />
                </Box>
                <button className="button" onClick={() => { handleSubmit() }} >Send</button>
                <div className="contentload">{isLoading && <Loading color="#5382c2" type="spin"
                />}</div>
            </div>

        </Card>
    )
}

export default IsCard